import axios from "axios";
// import store from "../store/index";
import Vue from 'vue';

class API {

  constructor(endpoint) {
    this.endpoint = endpoint;
    this.axios = axios.create({
      baseURL: '/cli/api',
      withCredentials: true,
    });

    // must be authenticated
    this.axios.interceptors.response.use((response) => {
      return response;
    }, (error) => {

      if (!error.response) {
        Vue.toasted.show("Encontrámos problemas de rede. Poderá estar sem rede ou sem acesso ao servidor...", {
          icon: 'fa-exclamation-triangle',
          action: {
            icon: 'fa-times',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          },
          type: "info",

        });
      } else if (error.response.status == 401) {

        Vue.$toast.warning("A sua sessão expirou... a redireccionar");
        window.location = "/admin/login";

      } else if (error.response.status == 422) {

        // the first error
        const firstError = Object.entries(error.response.data.errors)[0][1][0];
        Vue.$toast.error("Ocorreu um erro: <br><b> " + firstError + "</b>");

      }

        return Promise.reject(error);
    });
  }

  /**
   * Get all results
   */
  all() {
    return this.axios.get(this.endpoint);
  }

  /**
   * Get an item by Id
   * @param {any} id
   */
  find(id) {
    return this.axios.get(this.endpoint + `/${id}`);
  }

  /**
   * update an item
   * @param {any} id
   */
  update(id, data) {
    return this.axios.put(this.endpoint + `/${id}`, data);
  }

  /**
   * Create an item
   * @param {any} id
   */
  store(data) {
    return this.axios.post(this.endpoint, data);
  }

  /**
   * Delete an item
   * @param {*} id
   * @returns
   */
  delete(id) {
    return this.axios.delete(`${this.endpoint}/${id}`);
  }

  search(query) {
    return this.axios.get(`${this.endpoint}?search=${query}&perPage=100`);
  }

  geAddresses(recipient_id) {
    return this.axios.get(`${this.endpoint}/${recipient_id}/addresses?perPage=50`);
  }

}

export default API;
